import { Button, ButtonGroup, Form } from 'react-bootstrap';
import {
  faAngleLeft,
  faAngleRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

const PAGE_SIZES = [3, 5, 10, 25, 50];

export default function TablePagination({
  page,
  pages,
  pageSize,
  onChangePage,
  onChangeSize,
  isLoading,
}) {
  const handleChangeSize = (e) => onChangeSize(e.target.value);

  const renderPaginationPageSize = () => (
    <Form.Select
      id="table-pagination-size"
      name="table-pagination-size"
      value={pageSize}
      onChange={handleChangeSize}
      disabled={isLoading}
      size="sm"
    >
      {PAGE_SIZES.map((size) => (
        <option key={`page-option-${size}`} value={size}>
          {size}
        </option>
      ))}
    </Form.Select>
  );

  const renderPaginationButtons = () => {
    let arr = Array.from(Array(5).keys()).map((val) => val + 1);

    if (pages > 5) {
      if (page >= 3 && page <= pages - 3) {
        arr = [-2, -1, 0, 1, 2].map((val) => page + val);
      } else if (page > pages - 3) {
        arr = Array.from(Array(5).keys())
          .map((val) => pages - val)
          .reverse();
      }
    } else {
      arr = Array.from(Array(pages).keys()).map((val) => val + 1);
    }

    return arr.map((val) => {
      const handleClickPageBtn = () => onChangePage(val);

      return (
        <Button
          key={`TABLE_PAGINATION_PAGE_${val}`}
          variant={val === page ? 'primary' : 'light'}
          disabled={isLoading}
          className="btn btn-sm mx-1"
          onClick={handleClickPageBtn}
        >
          {val}
        </Button>
      );
    });
  };

  const handlePageMove = (move) => {
    let result;
    switch (move) {
      case 'start':
        result = 1;
        break;
      case 'prev':
        result = page - 1;
        break;
      case 'next':
        result = page + 1;
        break;
      case 'end':
        result = pages;
        break;
      default:
        result = page;
    }

    onChangePage(result);
  };

  const rendePaginationControls = () => (
    <ButtonGroup>
      {pages > 4 && (
        <>
          <Button
            variant={pages > 5 && page > 3 ? 'light' : 'secondary'}
            className="btn btn-sm"
            disabled={isLoading || !(pages > 5 && page > 3)}
            onClick={() => handlePageMove('start')}
          >
            <FontAwesomeIcon icon={faAngleDoubleLeft} />
          </Button>
          <Button
            variant={page > 1 ? 'light' : 'secondary'}
            className="btn btn-sm"
            disabled={isLoading || !(page > 1)}
            onClick={() => handlePageMove('prev')}
          >
            <FontAwesomeIcon icon={faAngleLeft} />
          </Button>
        </>
      )}
      {renderPaginationButtons()}
      {pages > 4 && (
        <>
          <Button
            variant={pages - page >= 1 ? 'light' : 'secondary'}
            className="btn btn-sm"
            disabled={isLoading || !(pages - page >= 1)}
            onClick={() => handlePageMove('next')}
          >
            <FontAwesomeIcon icon={faAngleRight} />
          </Button>
          <Button
            variant={pages > 5 && pages - page >= 3 ? 'light' : 'secondary'}
            className="btn btn-sm"
            disabled={isLoading || !(pages > 5 && pages - page >= 3)}
            onClick={() => handlePageMove('end')}
          >
            <FontAwesomeIcon icon={faAngleDoubleRight} />
          </Button>
        </>
      )}
    </ButtonGroup>
  );

  return (
    <div className="flex flex-row space-between">
      <div>{renderPaginationPageSize()}</div>
      <div>{rendePaginationControls()}</div>
    </div>
  );
}

TablePagination.propTypes = {
  isLoading: PropTypes.bool,
  page: PropTypes.number,
  pages: PropTypes.number,
  pageSize: PropTypes.number,
  onChangePage: PropTypes.func,
  onChangeSize: PropTypes.func,
};

TablePagination.defaultProps = {
  isLoading: false,
  page: 1,
  pages: 1,
  pageSize: 10,
  onChangePage: () => {},
  onChangeSize: () => {},
};
